export default class User {
  constructor(username, name, email, password) {
    this.username = username;
    this.name = name;
    this.email = email;
    this.password = password;
  }
}
